function Footer() {
  const init = () => {
    $(document).ready(() => {
      shareLinkDownloadApp();
    });
  };

  const shareLinkDownloadApp = () => {
    const { mobile, os } = window.aguadecoco.helpers.BrowserDetect.getBrowserInfo();
    if (mobile) {
      if (os === 'iOS') {
        $('a[href="#link-download-app"]').attr('href', 'https://apps.apple.com/us/app/%C3%A1gua-de-coco/id1592158293');
      } else if (os === 'Android') {
        $('a[href="#link-download-app"]').attr(
          'href',
          'https://play.google.com/store/apps/details?id=com.mobfiq.aguadecoco',
        );
      }
    }
  };

  init();
}

window.aguadecoco = window.aguadecoco || {};

Object.assign(window.aguadecoco, {
  widgets: Object.assign(window.aguadecoco.widgets || {}, {
    footer: new Footer(),
  }),
});
